import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { TID } from "@/constants/testIds";

export default function Login() {
    const nav = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    async function submit(e) {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            const u = await login(email.trim(), password);
            toast.success("Welcome back!");
            // redirect by role
            if (u.role === "admin") nav("/admin/overview");
            else if (u.role === "doctor")
                nav(u.doctor_status === "approved" ? "/doctor/dashboard" : "/doctor/pending");
            else nav("/dashboard");
        } catch (e2) {
            const detail = e2?.response?.data?.detail;
            setErr(typeof detail === "string" ? detail : "Sign-in failed.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="veda-container-narrow py-14 md:py-24">
            <div className="mx-auto max-w-md">
                <Link
                    to="/"
                    className="inline-flex items-center gap-1 text-xs font-medium text-veda-muted hover:text-veda-onSurface"
                >
                    <ArrowLeft size={14} /> Home
                </Link>
            <p className="mt-6 text-[10px] font-semibold uppercase tracking-[0.24em] text-veda-brand">
                Sushen Herbs
            </p>
            <h1 className="font-display mt-1 text-3xl text-veda-onSurface">
                Sign in
            </h1>
            <form onSubmit={submit} className="mt-6 flex flex-col gap-3">
                <input
                    type="email"
                    placeholder="Email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="border border-veda-border bg-veda-surface px-3 py-2.5 text-sm focus:border-veda-brand focus:outline-none"
                />
                <input
                    type="password"
                    placeholder="Password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="border border-veda-border bg-veda-surface px-3 py-2.5 text-sm focus:border-veda-brand focus:outline-none"
                />
                {err && <p className="text-xs text-veda-error">{err}</p>}
                <button
                    type="submit"
                    disabled={loading}
                    className="inline-flex items-center justify-center gap-2 bg-veda-brand px-4 py-2.5 text-sm font-semibold uppercase tracking-[0.14em] text-white disabled:opacity-70"
                >
                    {loading && <Loader2 size={14} className="animate-spin" />}
                    Sign in
                </button>
            </form>
            <p className="mt-6 text-xs text-veda-muted">
                New here?{" "}
                <Link
                    to="/auth/register"
                    className="text-veda-brand underline underline-offset-2"
                >
                    Create an account
                </Link>{" "}
                ·{" "}
                <Link
                    to="/auth/register-doctor"
                    data-testid={TID.docSignupLink}
                    className="text-veda-brand underline underline-offset-2"
                >
                    Apply as a Vaidya
                </Link>
            </p>
            </div>
        </div>
    );
}
